function Skills() {
  const skills = {
    "Cloud": ["AWS EC2", "S3", "RDS", "VPC", "ALB", "CloudFront", "Route53"],
    "Kubernetes": ["K3s", "Helm", "kubectl", "PVC", "Ingress", "RBAC"],
    "Observability": ["ELK Stack", "OpenSearch", "Prometheus", "Grafana", "Dynatrace"],
    "CI/CD": ["GitHub Actions", "Jenkins", "Docker", "Git"],
    "IaC": ["Terraform", "Bash Scripting", "Python"],
    "Databases": ["PostgreSQL", "MSSQL", "Redis", "RabbitMQ"],
  };

  return (
    <div className="bg-navy py-20 px-8" id="skills">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl font-bold text-slate-light mb-2">
          <span className="text-green font-mono text-xl">02. </span>
          Technical Skills
        </h2>
        <div className="w-64 h-px bg-navy-lighter mb-10"></div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {Object.entries(skills).map(([category, items]) => (
            <div key={category} className="bg-navy-light p-6 rounded border border-navy-lighter hover:border-green transition-all">
              <h3 className="text-green font-mono mb-4">{category}</h3>
              <div className="flex flex-wrap gap-2">
                {items.map(skill => (
                  <span key={skill} className="text-slate text-sm border border-navy-lighter px-3 py-1 rounded-full hover:border-green hover:text-green transition-all">
                    {skill}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Skills;